const webApiUrl = "/darshana/api/";

class FilesService {

    getFile = async (fileId: string) => {
        const options = {
            method: "GET",
        }
        const request = new Request(webApiUrl + "files/" + fileId, options);
        const response = await fetch(request);

        return response.blob();
    };

    getFileUrl(fileId: string): string {
        return webApiUrl + "files/" + fileId;
    }
}

export default FilesService;